<app-register-form (resultEvent)="orRegister($event)"></app-register-form>